import React from 'react';

export const DroneSoccerSolutions = () => {
  return (
    <section className="soccer-solutions-section">
      <h2 className="soccer-solutions-title">DRONE SOCCER SOLUTIONS</h2>
      <p className="soccer-solutions-description">
        Discover the thrill of drone soccer with premium equipment, full-on
        support, and a curriculum designed to inspire. Contact us today to start
        your team’s winning journey.
      </p>
      <div className="dreamX__discover--button">
        <a
          href="/drone-soccer-contact"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="btn btn--primary btn--med"
          onMouseDown={event => event.preventDefault()}
        >
          get in touch
        </a>
      </div>
    </section>
  );
};
